(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fa-grade-note"] && !Shopify.designMode) return;
  try {
    (() => {
    const note = ' (China’s highest hospital tier)';
    const apply = () => {
      const root = document.querySelector('main');
      if (!root || root.textContent.includes(note.trim())) return;
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const match = node.nodeValue.match(/Grade-A tertiary(?: hospitals?)?/);
        if (!match || node.parentElement.closest('[hidden], [aria-hidden="true"], script, style, template')) continue;
        const end = match.index + match[0].length;
        node.nodeValue = node.nodeValue.slice(0, end) + note + node.nodeValue.slice(end);
        return;
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
    else apply();
    document.addEventListener('shopify:section:load', apply);
  })();
  } catch(e) { console.error(e); }
})();

})();
